import { Link, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";

/**
 * Floating sticky pill that lets users jump to the AI Education Advisor
 * from anywhere on the site. Hidden when already inside the advisor flow
 * or when embedded in the admin dashboard.
 */
export default function AiAdvisorPill() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/ai-advisor") || pathname.startsWith("/admin") || pathname.startsWith("/design-sample")) return null;

  return (
    <Link
      to="/ai-advisor"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 px-4 py-3 rounded-full text-sm font-bold shadow-xl hover:-translate-y-1 transition-transform"
      style={{ background: "#0F172A", color: "#F0C948", border: "1px solid #F0C948" }}
      data-testid="ai-advisor-pill"
    >
      <Sparkles className="w-4 h-4"/>
      Ask EduTime AI Advisor
    </Link>
  );
}
